import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListCheckUncheckFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.12 12.788C7.77685 12.788 9.12 14.1311 9.12 15.7879C9.1199 17.4447 7.77679 18.7879 6.12 18.7879C4.4632 18.7879 3.12009 17.4447 3.12 15.7879C3.12 14.1311 4.46314 12.788 6.12 12.788ZM20.121 15.0379C20.535 15.0381 20.871 15.3738 20.871 15.7879C20.8709 16.202 20.535 16.5378 20.121 16.5379H11.3934C10.9793 16.5379 10.6435 16.2021 10.6434 15.7879C10.6434 15.3737 10.9792 15.0379 11.3934 15.0379H20.121ZM7.52917 5.21964C7.82206 4.92679 8.29684 4.92679 8.58972 5.21964C8.8826 5.51252 8.88258 5.98728 8.58972 6.28018L6.08972 8.78016C5.79682 9.07294 5.32203 9.07301 5.02917 8.78016L3.52917 7.28017C3.23635 6.98731 3.23641 6.51252 3.52917 6.21963C3.82206 5.92678 4.29684 5.92678 4.58972 6.21963L5.55945 7.18935L7.52917 5.21964ZM20.121 6.53799C20.535 6.53815 20.871 6.87387 20.871 7.28798C20.8709 7.70201 20.535 8.03781 20.121 8.03798H11.3934C10.9793 8.03798 10.6435 7.70211 10.6434 7.28798C10.6434 6.87377 10.9792 6.53799 11.3934 6.53799H20.121Z",
		fill: "currentColor"
	})
});
export default SvgListCheckUncheckFill;
